import $ from "jquery";

export const HomePage = () => {
  if (!($("#homepage").length > 0)) return false;

  const onNavClick = (e) => {
    const $el = $(e.currentTarget);
    const target = $el.attr("data-target");
    if (!target) {
      return false;
    }

    $el.siblings().removeClass("is-selected").attr("aria-selected", false);
    $el.addClass("is-selected").attr("aria-selected", true);

    const $pageItem = $(".kioskLayout__main");
    const $selectedItem = $pageItem.find("#target-" + target);
    $selectedItem.siblings().hide();
    $selectedItem.show();

    window.history.replaceState(null, null, window.location.pathname);
  };

  $(".kioskNavigation__item").on("click", onNavClick);

  document.addEventListener("selectstart", function (event) {
    event.preventDefault();
  });

  document.addEventListener(
    "contextmenu",
    function (e) {
      e.preventDefault();
    },
    false
  );
};
